import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useNav } from "../nav.tsx";
import { ErrorNote, errText, Field, SectionTitle } from "../ui.tsx";
import type { StageProps } from "./EmployeeShell.tsx";

export function IdentityStage({ api, detail, reload }: StageProps) {
  const { go } = useNav();
  const e = detail.employee;
  const [name, setName] = useState(e.name);
  const [jobTitle, setJobTitle] = useState(e.jobTitle);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string>();
  useEffect(() => {
    setName(e.name);
    setJobTitle(e.jobTitle);
  }, [e.id]);

  const dirty = name.trim() !== e.name || jobTitle.trim() !== e.jobTitle;

  return (
    <form
      className="grid max-w-xl gap-4"
      onSubmit={async (ev) => {
        ev.preventDefault();
        setBusy(true);
        setError(undefined);
        try {
          await api.updateEmployee(e.id, { name: name.trim(), jobTitle: jobTitle.trim() });
          await reload();
          go(`/employees/${e.id}/knowledge`);
        } catch (err) {
          setError(errText(err));
        } finally {
          setBusy(false);
        }
      }}
    >
      <SectionTitle title="Identity" description="What the employee is called and the job it holds. The interview is built around the job title." />
      <ErrorNote error={error} />
      <Field label="Name" htmlFor="emp-name" hint={e.avatarPin ? `Defaults to the avatar's name, ${e.avatarPin.avatarName}.` : undefined}>
        <Input id="emp-name" value={name} maxLength={80} required onChange={(x) => setName(x.target.value)} />
      </Field>
      <Field label="Job title" htmlFor="emp-title" hint="For example: Customer Support Lead, Accounts Payable Specialist, Recruiter.">
        <Input id="emp-title" value={jobTitle} maxLength={120} required onChange={(x) => setJobTitle(x.target.value)} />
      </Field>
      <div>
        <Button type="submit" disabled={busy || !name.trim() || !jobTitle.trim()}>
          {dirty ? "Save and continue" : "Continue"}
        </Button>
      </div>
    </form>
  );
}
